import { Link } from "react-router-dom";
import { ADDRESS, HOURS, TAGLINE } from "@/data/site";

export const SiteFooter = ({ brand }) => {
  const isZoryven = brand === "zoryven";
  return (
    <footer className={`py-12 border-t text-xs text-slate-500 ${isZoryven ? "bg-[#06140E] border-emerald-900/40" : "bg-slate-950 border-slate-900"}`} data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
        <div>
          <div className="font-condensed text-2xl uppercase text-white">Zoryven <span className={isZoryven ? "text-[#D48C46]" : "text-rose-400"}>×</span> Fancy Saloon</div>
          <p className="mt-2 max-w-xs leading-relaxed">{TAGLINE}</p>
        </div>
        <div className="flex flex-col gap-2">
          <span className="text-[10px] uppercase tracking-widest text-slate-600">Explore</span>
          <Link to="/" className="hover:text-slate-300" data-testid="footer-zoryven-link">Zoryven Hair Care</Link>
          <Link to="/saloon" className="hover:text-slate-300" data-testid="footer-saloon-link">Fancy Saloon</Link>
          <a href="#contact" className="hover:text-slate-300">Contact</a>
        </div>
        <div className="md:text-right" data-testid="footer-address">
          <div className="text-slate-400">{ADDRESS}</div>
          <div className="mt-1">{HOURS}</div>
        </div>
      </div>
    </footer>
  );
};
